import type { CompositePickerStore } from 'owa-calendar-composite-picker';
import { getStore } from '../store/store';

export function getCalendarChannelPickerStore(viewStateId: string | null): CompositePickerStore {
    const calendarChannelPickerStore = getStore().viewStates.get(viewStateId);
    if (calendarChannelPickerStore) {
        return calendarChannelPickerStore;
    } else {
        throw new Error('Calendar Channel Picker store missing for id: ' + viewStateId);
    }
}
